import * as Types from '@99designs/graph-utils/types';

export type ParticipantRole = 'DESIGNER' | 'CLIENT' | 'ADMIN';

interface ProjectForClientCheck {
    client?: Types.Maybe<{
        id: string;
    }>;
}

interface ProjectForDesignerCheck {
    designer?: Types.Maybe<{
        id: string;
    }>;
}

export function isDesignerFromUserId(project: ProjectForDesignerCheck, userId: string): boolean {
    return project.designer ? userId === project.designer.id : false;
}

export function isClientFromUserId(project: ProjectForClientCheck, userId: string): boolean {
    return project.client ? userId === project.client.id : false;
}

export function getParticipantRole(
    project: ProjectForClientCheck & ProjectForDesignerCheck,
    viewer: { id: string; isAdmin: boolean }
): ParticipantRole | null {
    if (isDesignerFromUserId(project, viewer.id)) {
        return 'DESIGNER';
    }

    if (isClientFromUserId(project, viewer.id)) {
        return 'CLIENT';
    }

    if (viewer.isAdmin) {
        return 'ADMIN';
    }

    return null;
}
